<template>
    <div class="dashboard">
        <h1>日別車両点検変更</h1>
        <ValidationObserver ref="observer" v-slot="{ invalid }" tag="div">
            <div class="l-w7 l-2-20-t--all">
                <div>
                    <h2>対象日</h2>
                    <div class="l-mt2 l-mb8">
                        <input v-model="params.date" type="date" :disabled="flagDisabled">
                    </div>
                    <h2>車両ID</h2>
                    <div class="l-mt2 l-mb10">
                        <input v-model="params.id" type="number" :disabled="flagDisabled">
                    </div>
                    <h2 class="l-mb10">車両の周り</h2>
                    <h3 class="l-mb4">灯火装置・方向指示器</h3>
                    <div class="l-mb10">
                        <input id="lighting_or_blinking" v-model="input.lighting_or_blinking" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="lighting_or_blinking">点灯又は点滅具合、汚れ・損傷</label>
                    </div>
                    <h3 class="l-mb4">タイヤ</h3>
                    <div>
                        <input id="tire_disc_wheel_installation" v-model="input.tire_disc_wheel_installation" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="tire_disc_wheel_installation">ディスク・ホイールの取付</label>
                    </div>
                    <div class="l-mt2">
                        <input id="tire_air_pressure" v-model="input.tire_air_pressure" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="tire_air_pressure">空気圧</label>
                    </div>
                    <div class="l-mt2">
                        <input id="tire_crack_damage" v-model="input.tire_crack_damage" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="tire_crack_damage">亀裂・損傷</label>
                    </div>
                    <div class="l-mt2 l-mb10">
                        <input id="tire_abnormal_wear" v-model="input.tire_abnormal_wear" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="tire_abnormal_wear">異常摩耗</label>
                    </div>
                    <h3 class="l-mb4">エア・タンク</h3>
                    <div class="l-mb10">
                        <input id="water_condensation" v-model="input.water_condensation" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="water_condensation">凝水</label>
                    </div>
                    <h3 class="l-mb4">積載</h3>
                    <div class="l-mb10">
                        <input id="agitator_internal_deposits" v-model="input.agitator_internal_deposits" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="agitator_internal_deposits">アジテータ内部の付着物</label>
                    </div>
                    <h2 class="l-mb10">運転席</h2>
                    <h3 class="l-mb4">ブレーキ</h3>
                    <div>
                        <input id="brake_stepping_on_and_effectiveness" v-model="input.brake_stepping_on_and_effectiveness" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="brake_stepping_on_and_effectiveness">踏みしろ及び効き</label>
                    </div>
                    <div class="l-mt2">
                        <input id="brake_amount_of_brake_fluid" v-model="input.brake_amount_of_brake_fluid" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="brake_amount_of_brake_fluid">ブレーキ液の量</label>
                    </div>
                    <div class="l-mt2">
                        <input id="brake_air_pressure" v-model="input.brake_air_pressure" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="brake_air_pressure">空気圧力</label>
                    </div>
                    <div class="l-mt2">
                        <input id="brake_exhaust_sound_from_the_valve" v-model="input.brake_exhaust_sound_from_the_valve" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="brake_exhaust_sound_from_the_valve">バルブからの排気音</label>
                    </div>
                    <div class="l-mt2 l-mb10">
                        <input id="brake_parking_brake_lever_pull" v-model="input.brake_parking_brake_lever_pull" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="brake_parking_brake_lever_pull">駐車ブレーキ・レバーの引きしろ</label>
                    </div>
                    <h3 class="l-mb4">原動機</h3>
                    <div class="l-mb10">
                        <input id="maintenance_flag" v-model="input.depth_abnormal_noise" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
                        <label for="maintenance_flag">かかり具合・異音</label>
                    </div>
                    <h2>走行距離入力</h2>
                    <div class="l-mt3 l-mb8">
                        <input v-model="input.start_mileage" type="number" max="9999999999" min="0" placeholder="走行距離を数字で入力してください">
                    </div>
                </div>
                <div>
                    &nbsp;
                </div>
            </div>
            <div class="l-mt6 l-2-00-m--all">
                <div>
                    <button :class="`${classButtonStyle}cancel`" type="button" @click="$_goBack()">戻る</button>
                    <button :class="X_validatedButtonStyle" type="button" :disabled="$_setValidatedDisabled(invalid)" @click="$_modalOpen('updateVehicleInspections')">次へ</button>
                </div>
            </div>
        </ValidationObserver>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";

    export default {
        "mixins": [
            common,
        ],
        "props": {
            "date": {
                "required": true,
                "type": String,
            },
            "id": {
                "required": true,
                "type": String,
            },
        },
        data() {
            return {
                "classButtonStyle": "button--oval--",
                "flagDisabled": true,
                "input": {
                    "inspection_date": this.date,
                    "lighting_or_blinking": "0",
                    "tire_disc_wheel_installation": "0",
                    "tire_air_pressure": "0",
                    "tire_crack_damage": "0",
                    "tire_abnormal_wear": "0",
                    "water_condensation": "0",
                    "agitator_internal_deposits": "0",
                    "brake_stepping_on_and_effectiveness": "0",
                    "brake_amount_of_brake_fluid": "0",
                    "brake_air_pressure": "0",
                    "brake_exhaust_sound_from_the_valve": "0",
                    "brake_parking_brake_lever_pull": "0",
                    "depth_abnormal_noise": "0",
                    "start_mileage": "",
                    "end_mileage": "",
                    "mileage": "",
                },
                "inputType": "checkbox",
                "params": {
                    "id": this.id,
                    "date": this.date,
                    "month": null,
                },
                "valueFalse": "0",
                "valueTrue": "1",
            };
        },
        created() {
            this.setMonth();
            this.fetchingListVehicleInspections(this.id);
        },
        "methods": {
            setMonth() {
                const date = new Date(this.date);
                const year = date.getFullYear();
                const month = ("0" + (date.getMonth() + 1)).slice(-2);
                this.params.month = `${year}-${month}`;
            },
            modalAction(key) {
                if (key === "updateVehicleInspections") {
                    this.handleUpdate();
                } else if (key === "updateVehicleInspections--finished") {
                    this.$router.push({ "name": "offices_vehicle_inspections_list" });
                }
            },
            fetchingListVehicleInspections() {
                // 車両点検詳細データ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/vehicle_inspection_detail`,
                    this.$_requestConfig("params")
                ).then(response => {
                    const dateArray = response.data.date;
                    const inspection = dateArray.map((item) => {
                        if (item.inspection_date === this.date) {
                            return item;
                        }
                    }).filter(Boolean)[0];
                    if (inspection) {
                        this.input = inspection;
                    }
                }).catch(() => {
                    this.$_modalError("fetchingVehicleInspectionsError");
                });
            },
            handleUpdate() {
                // 日別車両点検データ更新
                this.input.mileage = this.input.start_mileage;
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/vehicle_inspection_dates/${this.params.id}/update`,
                    this.input,
                    this.$_requestConfig()
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
        },
    };
</script>
